import queryString from 'query-string'
import { computed, Ref } from 'vue'

import { ClinicType, FullClinicWidgetSettings, QueryParamsType } from '@/types'
import { useApi } from '@/utils'

export function getWebsites(
  params: QueryParamsType = {
    all: true,
    minimal: true,
    include_invite: false,
  }
) {
  const { apiFetch } = useApi()
  const qs = queryString.stringify(params)

  return apiFetch<ClinicType[]>({
    url: `/websites${qs ? `?${qs}` : ''}`,
    method: 'GET',
    useFetchOptions: { immediate: false },
  })
}

export function getWebsite(clinicId: Ref<string | number>) {
  const { apiFetch } = useApi()
  const url = computed(() => `/websites/${clinicId.value}`)

  return apiFetch<ClinicType>({
    url,
    method: 'GET',
    useFetchOptions: { immediate: false },
  })
}

export function getWebsiteSettings(clinicId: number) {
  const { apiFetch } = useApi()

  return apiFetch<FullClinicWidgetSettings>({
    url: `/websites/${clinicId}/widget-settings`,
    method: 'GET',
  })
}

export function useClinicsApi() {
  const { apiFetch } = useApi()

  const createClinic = (formData: FormData) => {
    return apiFetch<ClinicType>({
      url: '/websites',
      method: 'POST',
      fetchOptions: { body: formData },
    })
  }

  const updateClinic = (clinicId: number, formData: FormData) => {
    return apiFetch<ClinicType>({
      url: `/websites/${clinicId}`,
      method: 'POST',
      fetchOptions: { body: formData },
    })
  }

  return { createClinic, updateClinic }
}
